module.exports = __webpack_public_path__ + "static/img/bianzu.5045d7c6.png";